
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiStudyareaService {

  apiBase: string = '/api/Manage/StudyArea/Renew';

  constructor(private httpClient: HttpClient) { }

  saveStudyAreaRenewDetails(studyAreaDetails: any): Observable<any> {
    return this.httpClient.patch(`${this.apiBase}`, studyAreaDetails)
  }
}